<mat-card>
  <mat-card-title i18n="@@malus-title">Donner un Malus</mat-card-title>
  <mat-card-subtitle i18n="@@malus-subtitle">Sélectionner le joueur</mat-card-subtitle>
  <mat-card-content>
    <mat-radio-group class="radio-group" id="bonusSize" [(ngModel)]="bonusSize">
      <mat-radio-button class="radio-button" value="small" i18n="@@malus-smallMalus">Mini</mat-radio-button>
      <mat-radio-button class="radio-button" value="medium" i18n="@@malus-normalMalus">Normal</mat-radio-button>
      <mat-radio-button class="radio-button" value="big" i18n="@@malus-bigMalus">Grand</mat-radio-button>
    </mat-radio-group>
    <app-player-selector [onPlayerSelected]="onPlayerSelected"></app-player-selector>

    <div class="button-container">
      <button mat-raised-button color="primary" (click)="back()" i18n="@@malus-back">
        Retour
      </button>
    </div>
  </mat-card-content>

</mat-card>
